import React from "react";
import "./Spinner.styles.css";

const Spinner = ({ className = "", ...props }) => {
  return <div className={`sk-spinner ${className || ""}`} {...props}></div>;
};

export default Spinner;
